const dateISORegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIsoDateString = (value: any): boolean => value && typeof value === 'string' && dateISORegex.test(value)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleDates = (body: any): void => {
  if (body === null || body === undefined || typeof body !== 'object') {
    return
  }

  for (const key of Object.keys(body)) {
    const value = body[key]
    if (isIsoDateString(value)) {
      // eslint-disable-next-line no-param-reassign
      body[key] = new Date(value)
    } else if (typeof value === 'object') {
      handleDates(value)
    }
  }
}
